import { reverse } from 'named-urls'
import React from 'react'

import { ButtonClean } from '@fourthwall/components'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import { routing } from '@utils/routing'

import * as S from './CannotArchiveProductModalContent.styled'

type CannotArchiveProductModalContentProps = {
  parentOffers: Offer.ParentOffer[]
  onClose: () => void
}

export const CannotArchiveProductModalContent = ({
  parentOffers,
  onClose,
}: CannotArchiveProductModalContentProps) => {
  const parentOffersCount = parentOffers.length
  const isMultiple = parentOffersCount > 1

  return (
    <S.Container>
      <S.Main>
        This product cannot be archived because it's currently being used in{' '}
        {isMultiple ? 'other products' : 'another product'}.
      </S.Main>
      <S.Description>
        To archive this product, you'll need to remove it from{' '}
        {isMultiple ? 'those products' : 'that product'} first:
      </S.Description>
      <S.List>
        {parentOffers.map((parentOffer) => (
          <div key={parentOffer.id} style={{ display: 'inline-block' }}>
            <ButtonClean
              label={parentOffer.name}
              to={reverse(routing.products.all.product.self, {
                productId: parentOffer.id,
              })}
              onClick={onClose}
            />
          </div>
        ))}
      </S.List>
    </S.Container>
  )
}
